import { render, staticRenderFns } from "./LobbyCreateForm.vue?vue&type=template&id=2b0ac94f&scoped=true"
import script from "./LobbyCreateForm.vue?vue&type=script&lang=js"
export * from "./LobbyCreateForm.vue?vue&type=script&lang=js"
import style0 from "./LobbyCreateForm.vue?vue&type=style&index=0&id=2b0ac94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ac94f",
  null
  
)

export default component.exports